export default __webpack_public_path__ + "static/media/Measuring-tape-black.8b7fb82a.svg";